import * as React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Box,
  DialogTitle,
  Stack,
  InputLabel,
  Typography,
} from "@mui/material/";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import "./../genericModels.css";
import {useFormik } from "formik";
import * as Yup from "yup";
import FileUploader from "../../../../util/component/FileUploader";

export const CreateVehicleAttachment = (props: any) => {
  const setOpenAddDialog = props.setOpenCreatModal;

  const[fieldValues,setFieldValue] =React.useState<any>("");
  const [disabledButton, setDisabledButton] = React.useState<boolean>(false);
  let data = new FormData();
  const { t } = useTranslation(["operation"]);

    const closeAddMaintenanceModal = () => {
      props.setVehicleAttachment({
       notes: "",
       attachment: null,
       id:"",
       name:""
      });
      setOpenAddDialog(false);
    };
    
    
  // let validateForm = {
  //   description: Yup.string()
  //     .required(t("attachmentsvehicle.createAttachment.validationMessages")),
  // };
  // let validateFile = {
  //   file: Yup.string()
  //     .required(t("attachmentsvehicle.createAttachment.validationMessages")),
  // };

 const onUpload=(file:File) => {
      data.append('file', file);
      formik.setFieldValue('file',data)
      setDisabledButton(true);
    
  }
  const onRemove =() =>{
    data.append('file','');
    setFieldValue(data);
    setDisabledButton(false);
  }

  // const ValidateForm = Yup.object().shape(validateForm);
  const formik = useFormik({
    initialValues: {
      description: `${props.vehicleAttachment.notes}`,
      id: props.vehicleAttachment.id ? `${props.vehicleAttachment.id}` : `${props.vehicleId}`,
      file:fieldValues
    },
      // validationSchema: ValidateForm,
    onSubmit: (values) => {
         props.createorEditVehicle(values);
         setOpenAddDialog(false);
         closeAddMaintenanceModal();
    },
  });
 
   React.useEffect(()=>{
    if(formik.values.description.length === 0){
      setDisabledButton(false);
    }
    else{
      setDisabledButton(true);
    }
   },[formik.values.description.length])
 

  return (
    
    <Dialog
      fullWidth={true}
      PaperProps={{
        sx: {
          maxWidth: "784px !important",
          // minHeight: "333px",
          borderRadius: "4px",
          overflowY:'inherit'
        },
      }}
       open={true}
    >
      {/* {" "} */}
      <DialogTitle>
        <Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
           {props.vehicleAttachment.id ? (
           <Grid xs item className="createEditModal">
          {t("attachmentsvehicle.createAttachment.editTitle")}
        </Grid>
      ) : (
         <Grid xs item className="createEditModal">
          {t("attachmentsvehicle.createAttachment.title")}
        </Grid> 
      )}  
          <Grid xs item sx={{ justifyContent: "flex-end", display: "flex" }}>
            <CloseIcon
              color="disabled"
              fontSize="small"
              onClick={closeAddMaintenanceModal}
            />
          </Grid>
        </Grid>
      </DialogTitle>
      <form id="submit1" onSubmit={formik.handleSubmit}>
        <Box>

          <DialogContent
            sx={{ borderTop: "1px groove rgba(208, 208, 206, 1)" }}
          >
            <Box>
            <Grid container direction={'row'} columns={12} spacing={2}>
                <Grid item lg={props.vehicleAttachment.id?6:12}>
                <Box>
                <TextField
                fullWidth
                id="description"
                name="description"
                type="text"
                label={t("attachmentsvehicle.createAttachment.description")}
                value={formik.values.description}

                onChange={(e) => {
                  formik.setFieldValue("description", e.currentTarget?.value)
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description ? formik.errors.description : ""
                }
              />
              </Box>
                  </Grid>
               
             { props.vehicleAttachment.id && <Grid item lg={6}><Box>
               <TextField
                fullWidth
                id="file"
                name="file"
                type="text"
                disabled
                label={t("attachmentsvehicle.createAttachment.filename")}
                value={props.vehicleAttachment.name}

              />
              </Box></Grid>}

              </Grid>
              <div>
             {!props.vehicleAttachment.id && <FileUploader 
               onUpload={(file:File) =>onUpload(file)}
               onRemove={!props.vehicleAttachment.id ? onRemove :undefined} 
               uploadedFiles ={
                props.vehicleAttachment.id ? [
                  props.vehicleAttachment
               ]:undefined}
               acceptedFiles={{'text/pdf': ['.pdf'],'image/png': ['.png'],'image/jpg': ['.jpg'],'image/jpeg':['.jpeg'], 'image/tif': ['.tif'],'image/tiff': ['.tiff'],'image/bmp': ['.bmp'],}}
                // isDirectUpload ={false}
              />}
              </div>
              {/* <div>{fileError && <p>error</p>}</div> */}
            </Box>
          </DialogContent>

          <DialogActions style={{ background: "#F8F8F8" }}>
            <Stack direction="row" spacing={2.875} p={1} mr={3.625} >
              <Button
                variant="outlined"
                size="medium"
                             onClick={closeAddMaintenanceModal}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "#C8017D",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.cancel")}
                </Typography>
              </Button>
              <Button
                form="submit1"
                variant="contained"
                size="medium"
                type={"submit"}
                color="accent"
                disabled={disabledButton ?false:true}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 36,
                    color: "white",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.save")}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
        </Box>
      </form>
    </Dialog>
  );
};
